import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { Activity, ScrollText, Database, AlertTriangle } from 'lucide-react'
import { BulkOperationsList } from "@/components/mailbox-management/BulkOperationsList"
import { StagingSyncManagement } from "@/components/infrastructure/StagingSyncManagement"
import { WebhookFailureMonitor } from "@/components/dashboard/WebhookFailureMonitor"
import { WebhookMonitor } from "@/components/dashboard/WebhookMonitor"
import { WebhookRecoveryProgress } from "@/components/dashboard/WebhookRecoveryProgress"

const Logs = () => {
  return (
    <NewAppLayout fullWidth>
      <div className="space-y-8">
        <div className="border-l-4 border-blue-500 pl-6 py-2">
                  <h1 className="text-2xl font-semibold text-gray-900 mb-2">Activity Logs</h1>
                  <p className="text-gray-600">Monitor system activities, sync operations, bulk operations, and platform events</p>
                </div>

                <Tabs defaultValue="webhook-monitor" className="w-full">
                  <TabsList className="grid w-full grid-cols-3">
                    <TabsTrigger value="webhook-monitor">Webhook Monitor</TabsTrigger>
                    <TabsTrigger value="system-logs">System Logs</TabsTrigger>
                    <TabsTrigger value="sync-status">Sync Status</TabsTrigger>
                  </TabsList>

                  <TabsContent value="system-logs" className="space-y-6">
                    {/* Recent Bulk Operations */}
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <Activity className="h-5 w-5 text-blue-600" />
                          Mailbox/Domain Activity Log
                        </CardTitle>
                      </CardHeader>
                      <CardContent>
                        <BulkOperationsList />
                      </CardContent>
                    </Card>

                    {/* Placeholder for future log sections */}
                    <Card>
                      <CardHeader>
                        <CardTitle className="flex items-center gap-2">
                          <ScrollText className="h-5 w-5 text-gray-600" />
                          System Events
                        </CardTitle>
                      </CardHeader>
                      <CardContent>
                        <div className="text-center py-8 text-gray-500">
                          <ScrollText className="h-12 w-12 mx-auto mb-4 text-gray-300" />
                          <p className="text-sm">System events logging coming soon</p>
                          <p className="text-xs text-gray-400 mt-1">Error logs, sync activities, and system notifications will appear here</p>
                        </div>
                      </CardContent>
                    </Card>
                  </TabsContent>

                  <TabsContent value="webhook-monitor" className="space-y-6">
                    {/* Webhook Recovery Progress - Temporary monitoring */}
                    <WebhookRecoveryProgress />
                    
                    {/* Detailed Failure Analysis */}
                    <WebhookFailureMonitor />
                    
                    {/* Real-time Webhook Activity Monitor */}
                    <WebhookMonitor />
                  </TabsContent>

                  <TabsContent value="sync-status">
                    {/* Smartlead Staging Sync */}
                    <StagingSyncManagement />
                  </TabsContent>
        </Tabs>
      </div>
    </NewAppLayout>
  )
}

export default Logs